module.exports = __webpack_public_path__ + "static/media/arrow.7b4144a5.png";